import script from "./ResourceModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourceModal.vue?vue&type=script&lang=ts&setup=true"

import "./ResourceModal.vue?vue&type=style&index=0&id=1aef7432&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aef7432"]])

export default __exports__